import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, Film, Handshake, Landmark, CheckCircle2 } from "lucide-react";
import MarketingNav from "@/components/MarketingNav";
import MarketingFooter from "@/components/MarketingFooter";

export default function HowItWorks() {
  const { t } = useTranslation();
  const modalities = [
    {
      icon: Film,
      title: t("how.placement_title"),
      desc: t("how.placement_desc"),
      points: [
        t("how.placement_p1"),
        t("how.placement_p2"),
        t("how.placement_p3"),
        t("how.placement_p4"),
      ],
    },
    {
      icon: Handshake,
      title: t("how.sponsorship_title"),
      desc: t("how.sponsorship_desc"),
      points: [
        t("how.sponsorship_p1"),
        t("how.sponsorship_p2"),
        t("how.sponsorship_p3"),
        t("how.sponsorship_p4"),
      ],
    },
    {
      icon: Landmark,
      title: t("how.funds_title"),
      desc: t("how.funds_desc"),
      points: [
        t("how.funds_p1"),
        t("how.funds_p2"),
        t("how.funds_p3"),
        t("how.funds_p4"),
      ],
    },
  ];

  return (
    <div className="marketing-shell">
      <MarketingNav />
      <section className="relative mx-auto max-w-6xl px-6 py-24">
        <p className="eyebrow text-gold">{t("how.eyebrow")}</p>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight text-white mt-6 max-w-4xl">
          {t("how.hero_a")} <span className="italic text-gold">{t("how.hero_b")}</span> {t("how.hero_c")}
        </h1>
        <p className="mt-8 text-white/70 text-lg max-w-3xl">
          {t("how.subtitle")}
        </p>
      </section>

      <section id="modalidades" className="border-t border-white/5 bg-[#080F1B]">
        <div className="mx-auto max-w-6xl px-6 py-24 space-y-16">
          {modalities.map(({ icon: Icon, title, desc, points }) => (
            <div key={title} className="grid md:grid-cols-[1fr_2fr] gap-10 items-start">
              <div>
                <span className="inline-flex h-12 w-12 rounded-full bg-gold/15 text-gold items-center justify-center">
                  <Icon size={22} />
                </span>
                <h2 className="font-display text-4xl text-white mt-6">{title}</h2>
              </div>
              <div className="glass-card rounded-3xl p-8">
                <p className="text-white/75 leading-relaxed">{desc}</p>
                <ul className="mt-6 space-y-3">
                  {points.map((p) => (
                    <li key={p} className="flex gap-3 text-white/80">
                      <CheckCircle2 size={18} className="text-gold shrink-0 mt-0.5" />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="border-t border-white/5">
        <div className="mx-auto max-w-4xl px-6 py-20 text-center">
          <p className="eyebrow text-gold">{t("how.cta_eyebrow")}</p>
          <h2 className="font-display text-4xl md:text-5xl mt-4 text-white">
            {t("how.cta_title")}
          </h2>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/registro?role=creator" className="gold-cta rounded-full px-6 py-3 font-semibold inline-flex items-center gap-2" data-testid="button-how-creator">
              {t("how.cta_creator")} <ArrowRight size={16} />
            </Link>
            <Link to="/registro?role=sponsor" className="ghost-cta rounded-full px-6 py-3 font-semibold inline-flex items-center gap-2" data-testid="button-how-sponsor">
              {t("how.cta_sponsor")}
            </Link>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
